module.exports = __webpack_public_path__ + "static/img/btn_consult.14b74791.png";